import { create } from 'zustand'

// A participant the host (or anyone) can act on. `userId` is only present
// for authenticated users — guests and PSTN callers have an identity but
// no DB user, so DM/profile-stats actions are gated on `userId` being set.
export interface ParticipantTarget {
  userId?: string // present for authed users (== LiveKit identity)
  identity: string // userId | guest_<id> | phone:<num>
  subjectType: 'USER' | 'GUEST' | 'PHONE'
  displayName: string
  avatarUrl?: string | null
}

// Surrounding context the menu/drawer need to issue moderation calls and
// build the "open full profile" route. `isHost` gates the kick/ban actions.
export interface ParticipantCtx {
  channelId: string
  serverId?: string | null
  isHost: boolean
  voiceChannels?: { id: string; name: string }[]
}

interface State {
  menu: { target: ParticipantTarget; ctx: ParticipantCtx; x: number; y: number } | null
  drawer: { target: ParticipantTarget; ctx: ParticipantCtx } | null
  openMenu: (target: ParticipantTarget, ctx: ParticipantCtx, x: number, y: number) => void
  closeMenu: () => void
  openDrawer: (target: ParticipantTarget, ctx: ParticipantCtx) => void
  closeDrawer: () => void
}

// Global UI state for the shared participant context-menu + profile slide-over.
// Mounted once in VoiceManager; opened from any voice tile / participant row.
export const useParticipantActionsStore = create<State>((set) => ({
  menu: null,
  drawer: null,
  openMenu: (target, ctx, x, y) => set({ menu: { target, ctx, x, y } }),
  closeMenu: () => set({ menu: null }),
  // Opening the drawer dismisses the menu so the two never overlap.
  openDrawer: (target, ctx) => set({ drawer: { target, ctx }, menu: null }),
  closeDrawer: () => set({ drawer: null }),
}))
